<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Move Warehouse Item</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <header class="subtitle is-5">
            Product Being Moved
          </header>

          <div class="columns is-multiline" v-if="storageUnit">

            <div class="column is-one-quarter">
              <label class="label">
                Category
              </label>
              <div>
                {{ storageUnit.stocking_unit.product_master.product_category.category }}
              </div>
            </div>

            <div class="column is-one-quarter">
              <label class="label">
                Subcategory
              </label>
              <div>
                <span v-if="storageUnit.stocking_unit.product_master.product_subcategory">
                  {{ storageUnit.stocking_unit.product_master.product_subcategory.subcategory }}
                </span>
                <span v-else class="has-text-grey-light">
                  No subcategory
                </span>
              </div>
            </div>

            <div class="column is-half">
              <label class="label">
                Product
              </label>
              <div>
                <div>{{ storageUnit.stocking_unit.product_master.name }}</div>
                <div
                  class="help" 
                  v-if="storageUnit.stocking_unit.product_master.product_category.has_dimensions">
                  {{ lwt(storageUnit.stocking_unit) }}
                </div>
              </div>
            </div>
          </div>

          <hr>

          <div class="columns" v-if="currentStorage">
            <div class="column is-one-third">
              <label class="label">
                Current Warehouse
              </label>
              <div>
                ({{ currentLocation.warehouse.warehouse_code }}) 
                {{ currentLocation.warehouse.warehouse_name }}
              </div>
            </div>

            <div class="column is-one-third">
              <label class="label">
                Current Location
              </label>
              <div>
                ({{ currentLocation.location_code }})
                {{ currentLocation.location_name }}
              </div>
            </div>

            <div class="column is-one-third">
              <label class="label">
                Current Storage
              </label>
              <div>
                ({{ currentStorage.storage_code }})
                {{ currentStorage.storage_name }}
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">Move to Storage*</label>
            <v-select
              v-if="storages.length > 0 && currentStorage"
              required
              :item-text="(v) => `${v.storage_code}-${v.storage_name}`"
              item-value="id"
              :options="storages.filter(d => d.id != currentStorage.id)"
              v-model="storageId"
            />
          </div>

          <div class="columns" v-if="storageUnit">
            <div class="column is-half">
              <label class="label">Quantity Available*</label>
              <div class="mt-2">
                {{ storageUnit.qty - qty }}
              </div>
            </div>
            <div class="column is-half">
              <label class="label">Quantity To Move*</label>
              <v-text-field
                required
                type="number"
                placeholder="select quantity to move"
                v-model="qty"
                :rules="[(v) => (v <= storageUnit.qty) && (v != 0) || 'Quantity moved cannot be greater than quantity at this location']">
              </v-text-field>
            </div>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="move()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    storageUnit: {
      type: Object
    },
    currentStorage: {
      type: Object
    },
    currentLocation: {
      type: Object
    }
  },
  components: { 
    VForm, 
    VSelect,
    VTextField
  },
  data() {
    return {
      storageId: null,
      qty: null,
      valid: false,
    }
  },
  computed: {
    ...mapState("storages", ["storages"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("storages", ["getStorages"]),
    ...mapActions("warehouseLocation", [
      "moveStorageUnit"
    ]),
    initialize() {
      if (this.storages.length == 0) {
        this.getStorages({ per_page: 1000 });
      }
    },
    lwt(v) {
      return `L${v.length_in_str}" x W${v.width_in_str} x T${v.thick_in_str}`
    },
    move() {
      this.moveStorageUnit({
        locationId: this.currentLocation.id,
        data: { 
          from_storage_id: this.storageUnit.storage_id,
          to_storage_id: this.storageId,
          stocking_unit_id: this.storageUnit.stocking_unit_id,
          qty: this.qty
        } 
      }).then(() => this.close(true));
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
